import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import PublishBanner from './PublishBanner/PublishBanner';
import WebsiteSettings from './WebsiteSettings/WebsiteSettings';
import CongratsBanner from './CongratsBanner/CongratsBanner';
import './WebAdmin.styles.less';


const WebAdmin = ({ account, publishWebsite, themeGroupTitle, wedding, theme }) => {
  if (isEmpty(themeGroupTitle) && isEmpty(wedding)) {
    return null;
  }

  const publishBannerTitle = account.published ? 'Your website is visible to guests.' : 'Your website is not visible to guests.';

  return (
    <div className="mpr-webadmin">
      <PublishBanner
        title={publishBannerTitle}
        published={account.published}
        handleOnPublishWebsite={publishWebsite}
      />
      {account.published && <CongratsBanner />}
      <WebsiteSettings
        themeGroupTitle={themeGroupTitle}
        wedding={wedding}
        theme={theme}
      />
    </div>
  );
};

WebAdmin.propTypes = {
  account: PropTypes.shape({}),
  publishWebsite: PropTypes.func,
  page: PropTypes.shape({}),
  theme: PropTypes.shape({}),
  themeGroupTitle: PropTypes.string,
  wedding: PropTypes.shape({})
};

export default WebAdmin;



// WEBPACK FOOTER //
// ./src/components/manage/website/ManagePagesRedesign/WebAdmin/WebAdmin.jsx